<template>
  <div class="server-detail">
    <div class="jc-page-header">
      <el-page-header show-back-icon :title="$t('slb.serverGroup.virtualServerGroup')" @back="goBack" class="relative">
        <template slot="content">
          <span class="long-name" :title="groupName">
            {{groupName}}
          </span>
          <div class="jc-list__header--right">
            <a target="_blank" :href="Config.CPS_HELP_URL">{{ $t('slb.text.slbHelpDoc') }}</a>
            <drop-down-operation :operations="operates"
                                @clickSelectItem="selectOps"
                                :buttonTitle="$t('privateNetwork.operate')">
            </drop-down-operation>
          </div>
        </template>
      </el-page-header>
    </div>
    <div class="jc-page-content">
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('slb.serverGroup.virtualServerGroupDetail')">
          <el-table :data="serverGroupList"
                    style="width: 100%"
                    @filter-change="serverGroupFilterChange">
            <el-table-column :label="$t('slb.serverGroup.sourceType')">
              <template slot-scope="scope">
                {{ $t('slb.serverGroup.cps') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('slb.serverGroup.instanceName')"
                             min-width="130">
              <template slot-scope="scope">
                <el-tooltip placement="bottom"
                            :content="scope.row.name">
                  <a href="javascript:void(0)"
                     @click="jumpToSourceDetail(scope.row)"
                     class="cell-text">
                    {{ scope.row.name }}
                  </a>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slb.serverGroup.instanceId')"
                             prop="instanceId" min-width="200">
              <template slot-scope="scope">
                <el-tooltip placement="bottom" :content="scope.row.instanceId">
                  <p class="cell-text">{{ scope.row.instanceId }}</p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slb.serverGroup.region')"
                             prop="az"
                             column-key="az"
                             key="az">
              <template slot-scope="scope">
                <span>{{ transformInstanceRegion(scope.row.az) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('eip.text.targetPrivateIpAddress')"
              min-width="140">
              <template slot-scope="scope">
                <p v-if="scope.row.iptype === '0'">{{`${scope.row.rip}(${$t('privateNetInstance.intranetIp')})`}}</p>
                <p v-else>
                  {{`${scope.row.aliasip}(${$t('subnet.text.ipAlias')})`}}
                </p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('slb.serverGroup.port')" prop="port"></el-table-column>
            <el-table-column :label="$t('slb.serverGroup.weights')"
                             prop="weight"></el-table-column>
            <el-table-column :label="$t('slb.serverGroup.status')"
                             prop="status"
                             column-key="status"
                             key="status">
              <template slot-scope="scope">
                {{InstanceStatusMapConstant[scope.row.status] | maybeEmpty}}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <div v-if="total > 0"
             ref="footer"
             class="jc-page-footer-detail block jc-container-table-actionBar">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="pageSizes"
                         :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </el-tabs>
    </div>
    <add-server v-if="openServer"
        :visible.sync="openServer"
        :operationType="'edit'"
        :title="$t('slb.serverGroup.editVirtualServerGroup')"
        :loadBalancerId="loadBalancerId"
        :region="region"
        :rowInfo="rowInfo"
        :slbVpcName="slbVpcName"
        @handleClickAdd="afterClickAdd">
    </add-server>
  </div>
</template>

<script>

import DropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import AddServer from '@/components/slb/detail/defaultServerGroup/Addserver';
import { remove_virtual_servers } from '@/common/SlbPopHelper';
import { InstanceStatusMapConstant} from '@/common/Constants'

export default {
  name: 'ServerDetail',
  components: {
    DropDownOperation,
    AddServer,
  },
  data() {
    return {
      total: 0, // 资源总数
      currentPage: 1, // 当前页数
      pageSizes: [20, 50, 100], // 每页查询数量
      pageSize: 20, // 当前每页数量
      serverGroupList: [], // 虚拟服务器列表
      // 获取的过滤值
      serverGroupFilters: {
        azs: [],
        status: []
      },
      // 选定的过滤值
      serverGroupFilterParams: {
        az: '',
        status: ''
      },
      region: '', // 当前区域
      operates: [
        {
          operateName: this.$t('slb.text.edit'),
          disabled: false,
          tip: '',
          value: 'edit'
        },
        {
          operateName: this.$t('slb.text.delete'),
          disabled: false,
          tip: '',
          value: 'delete'
        }
      ], // 操作
      groupName: '', // 服务器组名称
      openServer: false, // 虚拟服务器组弹窗是否可见
      serverGroupId: '', // 服务器组id
      loadBalancerId: '', // 负载均衡id
      rowInfo: {} // 编辑时传入组件的rowInfo
    };
  },
  computed: {
    InstanceStatusMapConstant : () =>{
      return InstanceStatusMapConstant
    }
  },
  methods: {
    /**
     * 转换虚拟服务器组详情可用区显示状态
     * @param region
     * @return String
     */
    transformInstanceRegion(region) {
      let regionName = '';
      this.serverGroupFilters.azs.forEach((az) => {
        if (az.value === region) {
          regionName = az.text;
        }
      });
      return regionName;
    },
    /**
     * 转化实例状态显示
     * @param status
     * @return String
     */
    transformInstanceStatus(status) {
      switch (status) {
        case 'running':
          return this.$t('privateNetInstance.statueNames.running');
        case 'stopped':
          return this.$t('privateNetInstance.statueNames.stopped');
        default:
          return status;
      }
    },
    /**
     * 确认编辑后回调
     * @param serverGroupName
     * @param chosenList
     * @param operationType
     * @param serverGroupId
     * @param deleteList
     */
    afterClickAdd(serverGroupName, chosenList, operationType, serverGroupId, deleteList) {
      this.editServerGroups(serverGroupName, chosenList, serverGroupId, deleteList);
    },
    /**
     * 编辑虚拟服务器组
     * @param name
     * @param servers
     * @param serverGroupId
     * @param deleteList
     */
    editServerGroups(name, servers, serverGroupId, deleteList) {
      const update = servers.map(server => {
        if (server.iptype) {
          if (server.iptype === '0') {
            server.rip = server.selectedIpAddress
          } else {
            server.aliasip = server.selectedIpAddress
          }
        } else {
          if (server.selectedIpAddress === server.privateIp || server.selectedIpAddress === server.extensionPrivateIp) {
            server.rip = server.selectedIpAddress
          } else {
            server.aliasip = server.selectedIpAddress
          }
        }
        return {
          instanceId: server.instanceId,
          port: server.port.toString(),
          weight: server.weight.toString(),
          serverId: typeof server.serverId === 'undefined' ? null : server.serverId,
          action: 'update',
          nicMode: server.interfaceMode || server.nicMode,
          interfaceName: server.interfaceName,
          rip: server.rip,
          aliasip: server.aliasip
        }
      });
      deleteList = deleteList.map(server => ({
        instanceId: server.instanceId,
        port: server.port.toString(),
        weight: server.weight.toString(),
        serverId: server.serverId,
        action: 'delete',
        nicMode: server.interfaceMode || server.nicMode,
        interfaceName: server.interfaceName,
        rip: server.iptype === '0' ? server.selectedIpAddress : '',
        aliasip: server.iptype === '1' ? server.selectedIpAddress : ''
      }));
      const serverSpec = update.concat(deleteList)
      const params = {
        region: this.region,
        loadBalancerId: this.loadBalancerId,
        clientToken: Normal.getClientToken(),
        name,
        serverGroupId,
        serverSpec
      };
      console.log('editServerGroups')
      console.log(params)
      Ajax.post('api/cps/serverGroups', params, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(() => {

      }).catch(async (err) => {
        const { response } = err.data;
        try {
          const json = await response.json();
          this.$message.error(json.errmsg);
        } catch (ex) {
          console.log(ex);
        }
      }).finally(() => {
        const refreshParams = {
          pageSize: 20,
          pageNumber: 1
        };
        this.refreshGroupList(refreshParams);
      });
    },
    /**
     * 将基础信息放到rowInfo中
     */
    makeRowInfo() {
      this.rowInfo.name = this.groupName;
      this.rowInfo.serverGroupId = this.serverGroupId;
    },
    /**
       * 点击跳转实例详情
       * @param row
       * 前端临时兼容，后期后端返回sn
       */
    jumpToSourceDetail(row) {
        const params = {
          region: row.region,
          instanceId: row.instanceId,
          az: row.az,
        };
        Ajax.get('/api/cps/getInstanceInfo', params)
        .then((res) => {
            if (res.data) {
                row.sn = res.data.instance.sn;
                this.$router.push({
                  path: '/instance/vpc/detail',
                  query: {
                    region: row.region,
                    az: row.az,
                    id: row.instanceId,
                    azName: row.azName,
                    sn: row.sn,
                    tabName: 'sourceInfo'
                  }
                });
            }
        }).catch(async (err) => {
            const { response } = err.data;
            try {
            const json = await response.json();
            this.$message.error(json.errmsg);
            } catch (e) {
            console.log(e);
            }
        });

    },

    /**
       * 返回负载均衡详情页虚拟服务器tab
       */
    goBack() {
      this.$router.push({
        path: '/lb/detail',
        query: {
          activeTabName: 'defaultServerGroup',
          region: this.region,
          loadBalancerId: this.loadBalancerId
        }
      });
    },
    /**
       * 点击下拉操作后调用
       * @param item
       */
    selectOps(item) {
      console.log(item, 'selected--operation');
      if (item === 'edit') {
        this.openServer = true;
      } else if (item === 'delete') {
        const params = {
          serverGroupId: this.serverGroupId,
          region: this.region,
          name: this.groupName
        };
        remove_virtual_servers(this, params, 'detail');
      }
    },
    /**
       * 每页数量改变时
       * 将当前页数置为第一页
       * @param size
       */
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.refreshGroupList({});
    },
    /**
       * 改变页码时
       * @param current
       */
    handleCurrentChange(current) {
      this.currentPage = current;
      this.refreshGroupList({});
    },
    /**
       * table绑定的filter-change
       * 切换时将当前页数置为1
       * @param filter
       */
    serverGroupFilterChange(filter) {
      this.currentPage = 1;
      const params = {};
      Object.keys(filter).forEach((key) => {
        if (key === 'az') {
          this.serverGroupFilterParams.az = filter[key][0];
        } else if (key === 'status') {
          this.serverGroupFilterParams.status = filter[key][0];
        }
        params[key] = filter[key][0];
      });
      this.refreshGroupList(params);
    },
    /**
       * 获得当前虚拟服务器组下面
       * 虚拟服务器过滤字段
       */
    getServerGroupFilters() {
      const params = {
        region: this.region,
        networkType: 'vpc'
      };
      Ajax.get('/api/filter/listListeners', params)
        .then((res) => {
          Object.keys(res.data).forEach((key) => {
            const filtersArray = []; const
              filtersObj = res.data[key];
            Object.keys(filtersObj).forEach((item) => {
              const temp = {};
              temp.value = item;
              temp.text = filtersObj[item];
              filtersArray.push(temp);
            });
            this.serverGroupFilters[key] = filtersArray;
          });
        });
    },
    /**
       * 获取当前虚拟服务器组下所有服务器
       * @param params
       */
    getServerGroupList(params) {
      Ajax.get('/api/cps/serverGroups/listServers', params)
        .then((res) => {
          if (res.data) {
            this.serverGroupList = res.data.servers;
            this.total = res.data.totalCount;
          }
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        });
    },
    /**
       * 刷新列表
       * @param params
       */
    refreshGroupList(params) {
      const defaultParams = {
        region: this.region,
        serverGroupId: this.serverGroupId,
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      };
      Object.keys(this.serverGroupFilterParams).forEach((key) => {
        if (this.serverGroupFilterParams[key]) {
          defaultParams[key] = this.serverGroupFilterParams[key];
        }
      });
      const realParams = Object.assign({}, defaultParams, params);
      this.getServerGroupList(realParams);
    },
  },
  created() {
    this.region = this.$route.query.region;
    this.groupName = this.$route.query.groupName;
    this.serverGroupId = this.$route.query.serverGroupId;
    this.loadBalancerId = this.$route.query.loadBalancerId;
    this.slbVpcName = this.$route.query.slbVpcName;
    this.makeRowInfo();
    this.refreshGroupList({});
    this.getServerGroupFilters();
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/detailCommon.scss";
  .server-detail {
    .jc-page-footer-detail {
      height: 56px;
        // width: calc(100% - 48px);
        width: 100%;
        z-index: 99;
        // padding: 0px 24px;
        padding: 0 10px 0 0;
        bottom: 0px;
    }

    .cell-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .jc-page-footer-detail .el-pagination {
      position: relative;
      float: right;
      top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/slb/detail/serverGroup/detail/ServerDetail.vue